import { Interp, css } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function PollForm({ v }) {
  if (!v.showPollNew) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closePollForm}>
        <div className="gp-venster" style={{ "width": "min(640px,100%)", "maxHeight": "calc(100vh - 60px)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "15px", "overflowY": "auto", "boxSizing": "border-box" }} onClick={v.stopProp}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
            <button onClick={v.closePollForm} className="gp-btn" title="Terug naar modgereedschap" style={{ "flex": "0 0 auto", "gap": "7px", "marginRight": "10px" }}>
              {' '}
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.1" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6" />
              </svg>
              {"\n          Terug\n        "}
            </button>
            <span style={{ "fontSize": "20px", "flex": "0 0 auto" }}>
              🗳️
            </span>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "2px", "flex": "1 1 auto", "minWidth": "0" }}>
              <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.2" }}>
                Poll aanmaken
              </div>
            </div>
            <button onClick={v.closePollForm} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={22} />
            </button>
          </div>
          <div>
            {' '}
            <div style={{ "fontSize": "13px", "fontWeight": "600", "height": "19px", "marginBottom": "5px" }}>
              Vraag
            </div>
            {' '}
            <input type="text" value={v.pollQ ?? ''} onInput={v.onPollQ} placeholder="Bijv. welke vind jij leuker?" />
            {' '}
          </div>
          <div style={css(v.pollFormGridStyle)}>
            {' '}
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "7px", "minWidth": "0" }}>
              <div style={{ "fontSize": "13px", "fontWeight": "600" }}>
                Keuze A
              </div>
              <input type="text" value={v.pollA ?? ''} onInput={v.onPollA} placeholder="Naam van keuze A" />
              <label onDragOver={v.onPollDragOverA} onDragLeave={v.onPollDragLeaveA} onDrop={v.onPollDropA} style={css(v.pollDropStyleA)}>
                {' '}
                {v.hasPollPrevA ? (<>
                  {' '}
                  <img alt="" src={v.pollPrevA} style={{ "maxWidth": "100%", "maxHeight": "118px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "block" }} />
                  {' '}
                </>) : null}
                {' '}
                {v.noPollPrevA ? (<>
                  {' '}
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="3" />
                    <circle cx="9" cy="9" r="1.6" />
                    <path d="m21 15-5-5L5 21" />
                  </svg>
                  {' '}
                </>) : null}
                {' '}
                <span style={{ "fontSize": "12px", "fontWeight": "600", "textAlign": "center", "lineHeight": "1.4" }}>
                  <Interp v={v.pollHintA} />
                </span>
                {' '}
                <input type="file" accept="image/*" onChange={v.onPollFileA} style={{ "display": "none" }} />
                {' '}
              </label>
            </div>
            {' '}
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "7px", "minWidth": "0" }}>
              <div style={{ "fontSize": "13px", "fontWeight": "600" }}>
                Keuze B
              </div>
              <input type="text" value={v.pollB ?? ''} onInput={v.onPollB} placeholder="Naam van keuze B" />
              <label onDragOver={v.onPollDragOverB} onDragLeave={v.onPollDragLeaveB} onDrop={v.onPollDropB} style={css(v.pollDropStyleB)}>
                {' '}
                {v.hasPollPrevB ? (<>
                  {' '}
                  <img alt="" src={v.pollPrevB} style={{ "maxWidth": "100%", "maxHeight": "118px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "12px", "background": "#fff", "display": "block" }} />
                  {' '}
                </>) : null}
                {' '}
                {v.noPollPrevB ? (<>
                  {' '}
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="3" />
                    <circle cx="9" cy="9" r="1.6" />
                    <path d="m21 15-5-5L5 21" />
                  </svg>
                  {' '}
                </>) : null}
                {' '}
                <span style={{ "fontSize": "12px", "fontWeight": "600", "textAlign": "center", "lineHeight": "1.4" }}>
                  <Interp v={v.pollHintB} />
                </span>
                {' '}
                <input type="file" accept="image/*" onChange={v.onPollFileB} style={{ "display": "none" }} />
                {' '}
              </label>
            </div>
            {' '}
          </div>
          {v.hasPollFormError ? (<>
            <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600" }}>
              <Interp v={v.pollFormError} />
            </div>
          </>) : null}
          <button onClick={v.createPoll} className="gp-btn pink" disabled={v.pollCreating} style={css(v.hoofdKnopStyle)}>
            <Interp v={v.pollCreateLabel} />
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
